import {
  CollaborationPolicyNameEnum,
  DpBuiltinEnum,
  MailPolicyNameEnum,
} from './types';
import { Service } from '@Types/app';

//for shared constants
export enum PolicyTypeEnum {
  Exchange = 1,
  SharePoint = 2,
  OneDrive = 3,
  Box = 4,
  Dropbox = 5,
  GoogleDrive = 6,
  SalesforceSandbox = 9,
  SalesforceProduction = 10,
  Gmail = 21,
  GmailInline = 22,
  // MicrosoftIdentityProtection = 35,
  Teams = 41,
  TeamsChat = 42,
  // MIP = 46,
  // ExchangeServer = 51,
  ExchangeInline = 82,
}

export const PolicyServiceMap = {
  [PolicyTypeEnum.Exchange]: Service.Exchange,
  [PolicyTypeEnum.SharePoint]: Service.SharePoint,
  [PolicyTypeEnum.OneDrive]: Service.OneDrive,
  [PolicyTypeEnum.Box]: Service.Box,
  [PolicyTypeEnum.Dropbox]: Service.Dropbox,
  [PolicyTypeEnum.GoogleDrive]: Service.GoogleDrive,
  [PolicyTypeEnum.SalesforceSandbox]: Service.SalesforceSandbox,
  [PolicyTypeEnum.SalesforceProduction]: Service.SalesforceProduction,
  [PolicyTypeEnum.Gmail]: Service.Gmail,
  [PolicyTypeEnum.GmailInline]: Service.GmailInline,
  // no microsoftIdentityProtection service
  // [PolicyTypeEnum.MicrosoftIdentityProtection]: Service.Exchange,
  [PolicyTypeEnum.Teams]: Service.Teams,
  [PolicyTypeEnum.TeamsChat]: Service.TeamsChat,
  // no MIP service
  // [PolicyTypeEnum.MIP]: Service.Exchange,
  // [PolicyTypeEnum.ExchangeServer]: Service.ExchangeServer,
  [PolicyTypeEnum.ExchangeInline]: Service.ExchangeInline,
};

export enum PolicyModeEnum {
  CommonPolicy = 0,
  DefaultPolicy = 1,
  DefaultMonitorPolicy = 2,
  DefaultXDRMonitorPolicy = 3,
  AssessmentPolicy = 11,
}

export const MAIL_POLICY_TYPE_ID_NAME_MAP: {
  [id: number]:
    | MailPolicyNameEnum
    | { 0: MailPolicyNameEnum; 1: MailPolicyNameEnum };
} = {
  1: MailPolicyNameEnum.Exchange,
  82: {
    0: MailPolicyNameEnum.ExchangeInlineInbound,
    1: MailPolicyNameEnum.ExchangeInlineOutbound,
  },
  21: MailPolicyNameEnum.Gmail,
  22: {
    0: MailPolicyNameEnum.GmailInlineInbound,
    1: MailPolicyNameEnum.GmailInlineOutbound,
  },
};

export const MAIL_POLICY_TYPE_IDS = Object.keys(MAIL_POLICY_TYPE_ID_NAME_MAP);

export const COLLABORATION_POLICY_TYPE_ID_NAME_MAP: {
  [id: number]: CollaborationPolicyNameEnum;
} = {
  2: CollaborationPolicyNameEnum.SharePoint,
  4: CollaborationPolicyNameEnum.Box,
  3: CollaborationPolicyNameEnum.OneDrive,
  5: CollaborationPolicyNameEnum.Dropbox,
  6: CollaborationPolicyNameEnum.GoogleDrive,
  9: CollaborationPolicyNameEnum.SalesforceSandbox,
  10: CollaborationPolicyNameEnum.SalesforceProduction,
  41: CollaborationPolicyNameEnum.Teams,
  42: CollaborationPolicyNameEnum.TeamsChat,
};

export const COLLABORATION_POLICY_TYPE_IDS = Object.keys(
  COLLABORATION_POLICY_TYPE_ID_NAME_MAP
);

export const buildInStringMap = new Map<DpBuiltinEnum, string>([
  [DpBuiltinEnum.UserDefined, 'policy.definedType.user'],
  [DpBuiltinEnum.Predefined, 'policy.definedType.predefined'],
]);

export const PolicyType4ManualScan = {
  1: PolicyTypeEnum.Exchange,
  2: PolicyTypeEnum.SharePoint,
  3: PolicyTypeEnum.OneDrive,
  4: PolicyTypeEnum.Box,
  5: PolicyTypeEnum.Dropbox,
  6: PolicyTypeEnum.GoogleDrive,
  21: PolicyTypeEnum.Gmail,
  41: PolicyTypeEnum.Teams,
};

export enum GmailInlinePolicyEvent {
  SwitchTargetType = 'SWITCH_TARGET_TYPE',
  SelectAllUserTarget = 'SELECT_ALL_USER_TARGET',
}
